/**
 * web-studio-sites D7: what the booking column's current state requires a
 * drawing to show, as its standard look draws it: the price and the terms
 * always; then nothing more while new bookings are paused; an event's fixed
 * time once known; a service's calendar with each open day and the chosen
 * day's times; and Continue unless bookings are paused or the event is closed.
 */
import type { RequiredPart, RequiredParts } from '../../contract/required';
import type { BookingColumnState } from './contract';
import { termsText } from './terms';

export const requiredParts: RequiredParts<BookingColumnState> = (state) => {
  const offering = state.kind === 'service' ? state.service : state.event;
  if (!offering) return [];
  const approval = Boolean(state.service?.requiresApproval);
  const parts: RequiredPart[] = [{ part: 'price' }];
  if (termsText(offering.payment, offering.price, approval)) parts.push({ part: 'terms' });
  if (approval) parts.push({ part: 'approval' });
  if (state.paused) return parts;
  if (state.event) {
    if (state.selectedDay && state.selectedStart) parts.push({ part: 'times' }, { part: 'time' });
  } else {
    parts.push({ part: 'calendar' }, ...state.openDays.map((day) => ({ part: 'day', item: day, action: 'pickDay' })));
    if (state.selectedDay) {
      parts.push({ part: 'times' }, ...state.times.map((t) => ({ part: 'time', item: t.startsAt, action: 'pickTime' })));
    }
  }
  if (!state.eventClosed) parts.push({ part: 'continue', action: 'continue' });
  return parts;
};
